import { render } from "./RichTextEditor.vue?vue&type=template&id=0643adea&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"

import "./RichTextEditor.vue?vue&type=style&index=0&id=0643adea&scoped=true&lang=css"

import exportComponent from "/Users/myeonghoonjeon/git/pawinhand_shelter_manager/PawinhandAPIServer/front/pawinhand_shelter_manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0643adea"]])

export default __exports__